export default __webpack_public_path__ + "static/media/LETO-JUDO-ACAP.8e1f7af1.mp3";